import { render, staticRenderFns } from "./o-w-tile-placeholder.vue?vue&type=template&id=42754229&"
import script from "./o-w-tile-placeholder.vue?vue&type=script&lang=js&"
export * from "./o-w-tile-placeholder.vue?vue&type=script&lang=js&"
import style0 from "./o-w-tile-placeholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports